import { QueryClient } from '@tanstack/react-query'

// Lives in its own module (not index.tsx) so non-React code — notably
// authService.logout, which every logout path funnels through — can clear it
// without an import cycle.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})
